import { CONSTS } from 'config/objectConst'

import { api } from '../api'

export type Plan = ReturnType<typeof usePlans>[number]

const BASIC_FEATURES = [
	'Connect people',
	'Export & filter contacts',
	'Automate follow-ups',
	'Run multiple campaigns',
	'Analyze campaigns',
	'Withdraw invites',
	'Run desktop automation',
	'Create custom lists'
]

const PRO_FEATURES = [
	'Use Sales Navigator',
	'Automate in cloud',
	'Manage messages',
	'Qualify leads',
	'Schedule messages',
	'Integrate Hubspot',
	'Enable webhooks'
]

export function usePlans() {
	const { data, isSuccess } = api.useSubscriptionQuery()

	const isActive = isSuccess && data.is_active
	const id = (isSuccess && data.plan_id) || ''
	const info = CONSTS.SUBSCRIPTIONS

	const isPro = id === info.PRO.ID
	const isTeam = id === info.TEAM.ID

	const result = [
		{
			active: isActive && isPro,
			arrayData: [...BASIC_FEATURES, ...PRO_FEATURES],
			description:
				'For individuals and professionals growing through lead generation.',
			featureColumns: [BASIC_FEATURES, PRO_FEATURES],
			id: info.PRO.ID,
			name: info.PRO.NAME,
			path: info.PRO.ID,
			price: info.PRO.PRICE
		},
		{
			active: isActive && isTeam,
			arrayData: [
				'ALL PRO features +',
				'Create a team',
				'Add team members',
				'Handle multiple accounts',
				'Oversee subscriptions',
				'Track team stats'
			],
			description: 'Perfect for managers streamlining team operations.',
			id: info.TEAM.ID,
			name: info.TEAM.NAME,
			path: info.TEAM.ID,
			price: info.TEAM.PRICE
		}
	]
	return result
}
